module.exports = __webpack_public_path__ + "static/media/checklist_blue.5da29d50.png";